import * as React from "react";
import { cn } from "@/lib/utils";
import { Mask } from "@/utils/mask";
import { Eye, EyeOff } from "lucide-react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  typeMask?:
    | "currency"
    | "cpfOrCnpj"
    | "cpf"
    | "phone"
    | "birthday"
    | "password";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, typeMask, onChange, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleMaskedInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value;
      switch (typeMask) {
        case "currency":
          value = Mask.formatCurrencyFromCents(
            Number(value.replace(/\D/g, ""))
          );
          break;
        case "cpfOrCnpj":
          value = Mask.maskCpfOrCnpj(value);
          break;
        case "cpf":
          value = Mask.maskCpf(value);
          break;
        case "phone":
          value = Mask.maskPhone(value);
          break;
        case "birthday":
          value = Mask.maskBirthday(value);
          break;
        default:
          break;
      }
      event.target.value = value;
      if (onChange) {
        onChange(event);
      }
    };

    return (
      <div className="relative">
        <input
          type={
            typeMask === "password"
              ? showPassword
                ? "text"
                : "password"
              : type
          }
          className={cn(
            "flex h-10 w-full bg-card rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50",
            typeMask === "password" && "pr-10",
            className
          )}
          ref={ref}
          onChange={handleMaskedInput}
          {...props}
        />
        {typeMask === "password" && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          >
            {showPassword ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
          </button>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
